import { render, staticRenderFns } from "./SelectMultiWidget.vue?vue&type=template&id=5b7fe389&scoped=true&"
import script from "./SelectMultiWidget.vue?vue&type=script&lang=js&"
export * from "./SelectMultiWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7fe389",
  null
  
)

export default component.exports